import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../config.json";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Box,
  Typography,
  Paper,
  CircularProgress,
  Divider,
} from "@mui/material";
import NavMenu from "../../components/navbar/NavMenu";
import TitleBar from "../../components/navbar/TitleBar";
import SubTitle from "../../components/common/SubTitle";
import ScheduleDetailsForm from "./ScheduleDetailsForm";
import StopSchedulesTable from "./StopSchedulesTable";
import ActionButtons from "./ActionButtons";

// API functions (unchanged)
async function createSchedule(schedule) {
  const response = await axios.post(`${config.baseURL}/schedule`, schedule, {
    withCredentials: true,
  });
  return response.data;
}

async function createStopSchedules(scheduleId, stopSchedules) {
  const response = await axios.post(
    `${config.baseURL}/schedule/stop`,
    {
      scheduleId,
      stopSchedules,
    },
    {
      withCredentials: true,
    }
  );
  return response.data;
}

async function updateSchedule(schedule) {
  try {
    console.log("this is schedule", schedule);
    const response = await axios.put(`${config.baseURL}/schedule`, schedule, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to update schedule", error);
  }
}

async function updateStopSchedules(stopSchedules) {
  try {
    console.log("this is stopSchedules", stopSchedules);
    const response = await axios.put(
      `${config.baseURL}/schedule/stop`,
      stopSchedules,
      {
      withCredentials: true,
    }
  );
  return response.data;
} catch (error) {
  console.error(error);
  throw new Error("Failed to update stop schedules", error);
}
}

async function getScheduleById(id) {
try {
  const response = await axios.get(
    `${config.baseURL}/schedule/id?scheduleId=${id}`,
    {
      withCredentials: true,
    }
  );
  console.log("Schedule by ID:", response.data);
  return response.data;
} catch (error) {
  console.error(error);
  throw new Error("Failed to fetch schedules", error);
}
}

async function getAllRoutes() {
try {
  const response = await axios.get(`${config.baseURL}/route/organization`, {
    withCredentials: true,
  });
  return response.data;
} catch (error) {
  throw new Error("Failed to fetch routes", error);
}
}

async function getAllVehicles() {
try {
  const response = await axios.get(`${config.baseURL}/vehicle/organization`, {
    withCredentials: true,
  });
  return response.data;
} catch (error) {
  throw new Error("Failed to fetch vehicles", error);
}
}

async function getStopByRouteCoordinate(longitude, latitude, organizationId) {
try {
  const response = await axios.get(
    `${config.baseURL}/stop/organization/location`,
    {
      params: { longitude, latitude, organizationId },
      withCredentials: true,
    }
  );
  return response.data;
} catch (error) {
  console.error("Failed to fetch organization locations", error);
}
}

async function getStopById(id) {
try {
  const response = await axios.get(`${config.baseURL}/stop/id?id=${id}`, {
    withCredentials: true,
  });
  return response.data;
} catch (error) {
  throw new Error("Failed to fetch organization locations", error);
}
}

function getFormattedDate(stopSchedules) {
let formattedStopSchedulesPromises = stopSchedules.map((stopSchedule) => {
  return getStopById(stopSchedule.stopId).then((stop) => {
    return {
      ...stopSchedule,
      stopName: stop.name,
    };
  });
});

return Promise.all(formattedStopSchedulesPromises)
  .then((formattedStopSchedules) => {
    console.log(formattedStopSchedules, "formattedStopSchedules");
    return formattedStopSchedules;
  })
  .catch((err) => {
    console.error("Error in getting formatted stop schedules:", err);
    return [];
  });
}

const AddSchedule = () => {
const { t } = useTranslation();
const { scheduleId } = useParams();
const navigate = useNavigate();
const parsedData = JSON.parse(localStorage.getItem("userState"));
const orgId = parsedData?.user?.organizationId;
const [schedule, setSchedule] = useState({
  name: "",
  description: "",
  startTime: new Date().toISOString(),
  endTime: new Date().toISOString(),
  repitation: "",
  organizationId: orgId,
  vehicleIds: [],
  routeId: "",
});
const [stopSchedules, setStopSchedules] = useState([]);
const [routes, setRoutes] = useState([]);
const [vehicles, setVehicles] = useState([]);
const [selectedRoute, setSelectedRoute] = useState(null);
const [loading, setLoading] = useState(false);
const [errors, setErrors] = useState({});
const location = useLocation();
const schedulesId = location.state || null;
const path = scheduleId || schedulesId ? "schedules > Update Schedule" : "schedules > Create Schedule";

useEffect(() => {
  const fetchData = async () => {
    try {
      setLoading(true);
      const [routesData, vehiclesData] = await Promise.all([
        getAllRoutes(),
        getAllVehicles(),
      ]);
      setRoutes(routesData);
      setVehicles(vehiclesData);

      if (scheduleId) {
        const scheduleData = await getScheduleById(scheduleId);
        setSchedule({
          ...scheduleData,
          vehicleIds: scheduleData.vehicleSchedule.map((vs) => vs.vehicle.id),
        });
        const formattedStopSchedules = await getFormattedDate(
          scheduleData.stopSchedules
        );
        setStopSchedules(formattedStopSchedules);
        setSelectedRoute(
          routesData.find((r) => r.id === scheduleData.routeId)
        );
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [scheduleId]);

useEffect(() => {
  if (routes.length > 0 && schedule) {
    const foundRoute = routes.find((r) => r.id === schedule.routeId);
    setSelectedRoute(foundRoute);
  }
}, [routes, schedule]);

const handleChange = async (e) => {
  let { name, value } = e.target;

  setErrors({
    ...errors,
    [name]: undefined,
  });

  if (name === "startTime" || name === "endTime") {
    value = value; // Already in ISO format from TimePicker
  }

  if (name === "routeId") {
    value = parseInt(value);
  }

  setSchedule((prevSchedule) => ({ ...prevSchedule, [name]: value }));

  if (name === "routeId" && value) {
    setLoading(true);
    const selectedRoute = routes.find((r) => r.id === value);
    console.log("Selected Route:", selectedRoute);

    if (selectedRoute && selectedRoute.routeCoordinates) {
      setSelectedRoute(selectedRoute);

      try {
        const stopPromises = selectedRoute.routeCoordinates.map(
          async (coord, index) => {
            const stopInfo = await getStopByRouteCoordinate(
              coord.longitude,
              coord.latitude,
              selectedRoute.organizationId
            );

            if (!stopInfo) {
              console.log("Stop not found for coordinates:", coord);
              return null;
            }

            return {
              order: index + 1,
              longitude: coord.longitude,
              latitude: coord.latitude,
              arrivalTime: "",
              departureTime: "",
              stopId: stopInfo.id,
              stopName: stopInfo.name,
            };
          }
        );

        const resolvedStops = await Promise.all(stopPromises);
        const filteredStops = resolvedStops.filter((stop) => stop !== null);
        console.log("Fetched stops:", filteredStops);
        setStopSchedules(filteredStops);
      } catch (error) {
        console.error("Error fetching stops:", error);
      } finally {
        setLoading(false);
      }
    }
  }
};

const handleVehicleChange = (e) => {
  const selectedOptions = e.target.value;
  console.log("Selected Vehicle IDs:", selectedOptions);
  setSchedule((prevSchedule) => ({
    ...prevSchedule,
    vehicleIds: selectedOptions,
  }));
};

const handleStopChange = (index, e) => {
  const { name, value } = e.target;

  const stopErrorKey = `stop-${index}-${name}`;
  setErrors({
    ...errors,
    [stopErrorKey]: undefined,
  });

  const updatedStops = [...stopSchedules];
  updatedStops[index] = { ...updatedStops[index], [name]: value };
  setStopSchedules(updatedStops);
};

const validateForm = () => {
  const newErrors = {};

  if (!schedule.name.trim()) {
    newErrors.name = "Schedule name is required";
  }

  if (!schedule.repitation) {
    newErrors.repitation = "Repetition is required";
  }

  if (!schedule.routeId) {
    newErrors.routeId = "Route is required";
  }

  if (!schedule.startTime) {
    newErrors.startTime = "Start time is required";
  }

  if (!schedule.endTime) {
    newErrors.endTime = "End time is required";
  }

  if (new Date(schedule.endTime) <= new Date(schedule.startTime)) {
    newErrors.endTime = "End time must be after start time";
  }

  if (!schedule.description.trim()) {
    newErrors.description = "Description is required";
  }

  if (stopSchedules.length > 0) {
    stopSchedules.forEach((stop, index) => {
      if (!stop.arrivalTime) {
        newErrors[`stop-${index}-arrivalTime`] = "Required";
      }

      if (!stop.departureTime) {
        newErrors[`stop-${index}-departureTime`] = "Required";
      }

      if (
        stop.arrivalTime &&
        stop.departureTime &&
        stop.departureTime < stop.arrivalTime
      ) {
        newErrors[`stop-${index}-departureTime`] =
          "Must be after arrival time";
      }
    });
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

const handleSubmit = async (e) => {
  e.preventDefault();
  if (!validateForm()) {
    return;
  }

  setLoading(true);

  const formattedSchedule = {
    ...schedule,
    startTime: new Date(schedule.startTime).toISOString(),
    endTime: new Date(schedule.endTime).toISOString(),
  };

  console.log("Formatted ISO Start Time:", formattedSchedule.startTime);
  console.log("Formatted ISO End Time:", formattedSchedule.endTime);

  try {
    let createdSchedule;
    if (scheduleId) {
      console.log(schedule, "schedule");
      createdSchedule = await updateSchedule(formattedSchedule);
    } else {
      createdSchedule = await createSchedule(formattedSchedule);
    }

    if (stopSchedules.length > 0 && stopSchedules[0].id) {
      console.log(stopSchedules, "stopSchedules");
      const formattedStopSchedules = stopSchedules.map((stopSchedule) => ({
        id: stopSchedule.id,
        arrivalTime: stopSchedule.arrivalTime,
        departureTime: stopSchedule.departureTime,
        stopId: stopSchedule.stopId,
      }));
      console.log(formattedStopSchedules, "formattedStopSchedules");

      await updateStopSchedules(formattedStopSchedules);
    } else if (stopSchedules.length > 0) {
      const formattedStopSchedules = stopSchedules.map((stopSchedule) => ({
        arrivalTime: stopSchedule.arrivalTime,
        departureTime: stopSchedule.departureTime,
        stopId: stopSchedule.stopId,
      }));
      await createStopSchedules(createdSchedule.id, formattedStopSchedules);
    }

    setTimeout(() => {
      navigate("/schedule");
    }, 1500);
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};

return (
  <Box sx={{ display: "flex", bgcolor: "#f5f5f5", minHeight: "100vh", minWidth: "100vw" }}>
    <Box sx={{ width: "100%" }}>
      <TitleBar />
      <NavMenu />
      <SubTitle title="schedules" path={path} />
      <Box maxWidth="lg" sx={{ mx: "40px", p: 0 }}>
        <Paper
          elevation={4}
          sx={{
            p: 2,
            borderRadius: 2,
            border: "1px solid #A5DCF3",
            position: "relative",
          }}
        >
          {loading && (
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgba(255, 255, 255, 0.7)",
                zIndex: 1000,
                borderRadius: 2,
              }}
            >
              <CircularProgress />
            </Box>
          )}
          <Box component="form" onSubmit={handleSubmit} noValidate>
            <Typography
              variant="h6"
              sx={{
                mb: 3,
                fontWeight: "bold",
                height: "50px",
                background: "#647490",
                display: "flex",
                alignItems: "center",
                justifyContent: "left",
                borderRadius: "8px",
                textAlign: "center",
                padding: "10px",
                color: "#FFFFFF",
              }}
            >
              {t("scheduleDetails")}
            </Typography>

            <ScheduleDetailsForm
              schedule={schedule}
              routes={routes}
              vehicles={vehicles}
              errors={errors}
              handleChange={handleChange}
              handleVehicleChange={handleVehicleChange}
            />

            {selectedRoute && stopSchedules.length > 0 && (
              <StopSchedulesTable
                stopSchedules={stopSchedules}
                errors={errors}
                handleStopChange={handleStopChange}
              />
            )}

            <Divider sx={{ my: 3 }} />

            <ActionButtons
              loading={loading}
              scheduleId={scheduleId}
              onCancel={() => navigate("/schedule")}
            />
          </Box>
        </Paper>
      </Box>
    </Box>
  </Box>
);
};

export default AddSchedule;